import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import './utils/styles/App.scss';
import Home from './components/Home/Home'

const TRACKING_ID = process.env.REACT_APP_TRACKING_ID;


function App() {

  useEffect(() => {
    if (TRACKING_ID) {
      ReactGA.initialize(TRACKING_ID);
      console.log("Google Analytics inicializado correctamente");
    } else {
      console.error("No se encontró un ID de seguimiento para Google Analytics.");
    }
  }, [])

  return (
    <>
      <Home></Home>
    </>
      
  );
}

export default App;
